"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _require = require("./constants"),
  HANDLERS = _require.HANDLERS;
var DateHandler = require("./handlers/DateHandler");
var E164PhoneHandler = require("./handlers/E164PhoneHandler");
var TimestampHandler = require("./handlers/TimestampHandler");
var DurationHandler = require("./handlers/DurationHandler");
var HandlerFactory = /*#__PURE__*/function () {
  function HandlerFactory() {
    (0, _classCallCheck2["default"])(this, HandlerFactory);
  }
  return (0, _createClass2["default"])(HandlerFactory, [{
    key: "getHandler",
    value: function getHandler(type, config) {
      switch (type) {
        case HANDLERS.E164Validator:
          return new E164PhoneHandler(config);
        case HANDLERS.DATE:
          return new DateHandler(config);
        case HANDLERS.TIMESTAMP:
          return new TimestampHandler(config);
        case HANDLERS.DURATION:
          return new DurationHandler(config);
        default:
          throw new Error("String service has no defined handler for type: ".concat(type));
      }
    }
  }]);
}();
var instance = new HandlerFactory();
module.exports = instance;